module.exports = __webpack_public_path__ + "12142e7e08414c8c6d62c34523ec858f.png";